import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const React = require("react");
import { config } from "../../../../Shared/config";
import { Link } from "../library/link";
export const CookiebarLayout = (props)=>{
    const { cookiebarRef, expanded, toggleExpand, toggleVideoCookies, videoCookies, savePreferences, onAcceptAllCookies, onDenyAllCookies } = props;
    const cookiesList = [
        {
            kind: 'functional',
            label: 'Functioneel. Deze cookies zijn nodig om de website goed te laten werken.',
            isAccepted: true,
            disabled: true
        },
        {
            kind: 'analytical',
            label: 'Analytisch. Met deze cookies analyseren we het gebruik van de website. We slaan geen persoonsgegevens op.',
            isAccepted: true,
            disabled: true
        },
        {
            kind: 'video',
            label: "Video's. Met deze cookies spelen we video's af op de website. (optioneel)",
            isAccepted: videoCookies,
            toggleCookie: toggleVideoCookies,
            disabled: false
        }
    ];
    return /*#__PURE__*/ _jsx("div", {
        className: "cookiebar",
        role: "alert",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "cookiebar__inner container--mg align--center",
            ref: cookiebarRef,
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "sr-text",
                    children: "Cookiebar"
                }),
                /*#__PURE__*/ _jsxs("p", {
                    className: "text--s text--styled",
                    children: [
                        "Om onze website zo goed mogelijk te gebruiken, is het nodig dat je onze cookies accepteert. Dat klinkt makkelijk en dat is het ook. Door op accepteren te klikken, geef je ons toestemming om cookies te plaatsen. Wil je dit liever niet? Dan kun je ervoor kiezen om alleen akkoord te gaan met minimale cookies. Hiermee analyseren we onze website en daarbij slaan we geen persoonsgegevens op. Lees voor meer informatie onze",
                        " ",
                        /*#__PURE__*/ _jsx(Link, {
                            url: config().privacyStatementUrl,
                            className: "cookiebar__link",
                            children: "privacyverklaring"
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "cookiebar__actions",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("button", {
                                    onClick: onAcceptAllCookies,
                                    className: "button button--primary",
                                    children: "Cookies accepteren"
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    onClick: onDenyAllCookies,
                                    className: "button button--tertiary",
                                    children: "Ik wil alleen minimale cookies"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            onClick: toggleExpand,
                            className: "link link--primary",
                            children: /*#__PURE__*/ _jsx("span", {
                                children: expanded ? "Minder keuzes" : "Meer keuzes"
                            })
                        })
                    ]
                }),
                expanded && /*#__PURE__*/ _jsxs("div", {
                    className: "cookiebar__extended",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "text--s text--styled",
                            children: "Hier kun je gedetailleerde cookie-instellingen aanpassen. Kies welke soorten cookies je wilt accepteren:"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "cookiebar__extended--options",
                            children: cookiesList.map((cookie, index)=>/*#__PURE__*/ _jsxs("div", {
                                    className: "form__checkbox",
                                    children: [
                                        /*#__PURE__*/ _jsx("input", {
                                            id: `${cookie.kind}_${index}`,
                                            className: 'form__input--checkbox',
                                            type: "checkbox",
                                            checked: cookie.isAccepted,
                                            onChange: cookie.toggleCookie ? cookie.toggleCookie : undefined,
                                            disabled: cookie.disabled,
                                            "aria-describedby": `${cookie.kind}_label`
                                        }),
                                        /*#__PURE__*/ _jsx("label", {
                                            id: `${cookie.kind}_label`,
                                            className: 'form__label--checkbox',
                                            htmlFor: `${cookie.kind}_${index}`,
                                            children: cookie.label
                                        })
                                    ]
                                }, `cookie_${index}`))
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            onClick: savePreferences,
                            className: "button button--primary",
                            children: /*#__PURE__*/ _jsx("span", {
                                className: "button__label",
                                children: "Instellingen opslaan"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
